export default __webpack_public_path__ + "static/media/five.f9284b32.svg";